// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"6ec17e25","990":"f0282e25"}[chunkId] + ".chunk.css";
};